import './App.scss'
import React, { useState, useEffect } from 'react'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import Faq from './components/Faq'
import navLogo from './assets/img/nav_logo.png'
import screenshot from './assets/img/screenshot.png'
import icon from './assets/img/icon.png'
import qrcode from './assets/img/qrcode.png'

function AppContent () {
    const [scrolling, setScrolling] = useState(false)
    const [isHovered, setIsHovered] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolling(true)
            } else {
                setScrolling(false)
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const handleMouseEnter = () => {
        setIsHovered(true)
    }

    const handleMouseLeave = () => {
        setIsHovered(false)
    }

    const handleLinkClickToTerms = () => {
        window.open('https://plantaid.ai/user-agreement/terms_of_use.html', '_blank')
    }

    const handleLinkClickToPrivate = () => {
        window.open('https://plantaid.ai/user-agreement/privacy_policy.html', '_blank')
    }

    const handleLocateToAppStore = () => {
        // window.open('https://apps.apple.com/us/app/fitmeal-health-fitness-recipe/id6504800448', '_blank')
    }

    return (
        <div className="App">
            <header className={scrolling ? "header header-scrolled" : "header"}>
                <div className='container'>
                    <div className='navL'>
                        <img src={navLogo} alt="" style={{ width: '176px' }} />
                    </div>
                    <div className='navR'>
                        <div className='store'>App Store</div>
                        <div
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            style={{ backgroundColor: isHovered ? ' #1F6246' : '#1F6246' }}
                            className='download'>
                            Download
                            {isHovered && (
                                <div className='qrCode'>
                                    <div className='triangle'>
                                        <img src="./triangle.png" alt="" />
                                    </div>
                                    <div className='qrcode'>
                                        <img src={qrcode} alt="" />
                                    </div>
                                    <div className='text'>
                                        <div>
                                            <img src="./scan.png" alt="" />
                                        </div>
                                        <div>Scan to download</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header>
            <div className='section'>
                <div className='left'>
                    <img src={screenshot} alt="" />
                </div>
                <div className='right'>
                    <div className='icon'>
                        <img src={icon} alt="" />
                    </div>
                    <div className='name'>PlantAID</div>
                    <div className='desc'>Meet PlantAID – an app providing expert-level plant care solutions. Unlock your inner gardener and ensure your plants thrive under your care! PlantAID identifies over 18,000 plant species with 99% accuracy and helps diagnose and cure plant diseases
                    </div>
                </div>
            </div>
            <footer className='footer'>
                <div className='container'>
                    <div className='footerL'>
                        <div className='title'>PlantAID</div>
                        <div className='copyright'>2026 © Vocalbeats.AI Pte. Ltd. All Rights Reserved.</div>
                    </div>
                    <div className='footerR'>
                        <div className='item'>
                            <div className='link'
                                onClick={handleLinkClickToPrivate}
                            >Privacy Policy
                            </div>
                        </div>
                        <div className='item'>
                            <div className='link'
                                onClick={handleLinkClickToTerms}
                            >Terms of Use
                            </div>
                        </div>
                        <div className='item'>
                            <div className='link emailText'
                            >support@plantaid.ai
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

function App () {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<AppContent />} />
                <Route path="/faq" element={<Faq />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App
